import RDatePicker, {registerLocale, setDefaultLocale} from "react-datepicker";

import "./datepicker.styles.css";
import "react-datepicker/dist/react-datepicker.css";

import it from "date-fns/locale/it";
registerLocale("it", it);
setDefaultLocale("it");

import {IonLabel} from "@ionic/react";
import {Controller} from "react-hook-form";
import {ErrorMessage} from "@hookform/error-message";
import dayjs from "dayjs";

interface IDatePicker {
  register: any;
  errors: any;
  control: any;
  registerName: string;
  name: string;
  pattern?: {
    value: RegExp | string;
    message: string;
  };
  requiredMessage?: string | false;
  onChange?: (e: any) => any;
  titleError?: string;
  min?: string;
  max?: string;
  validate?: any;
  disabled?: boolean;
  style?: React.CSSProperties;
}

const DatePicker = ({
  errors,
  registerName,
  name,
  onChange,
  titleError,
  control,
  min,
  max,
  requiredMessage,
  disabled,
  style,
}: IDatePicker) => {
  return (
    <div className="app-datepicker-wrapper">
      <IonLabel className="app-datepicker-label">
        {name}
        <span className="app-datepicker-title-error">{titleError}</span>
      </IonLabel>

      <Controller
        control={control}
        name={registerName}
        rules={requiredMessage ? {required: requiredMessage} : undefined}
        render={({field}) => (
          <div
            style={{
              position: "relative",
            }}
          >
            <RDatePicker
              dateFormat="dd-MM-yyyy"
              showPopperArrow={false}
              showYearDropdown
              scrollableYearDropdown
              showMonthDropdown
              selected={field.value ? dayjs(field.value).toDate() : null}
              onChange={(date) => {
                field.onChange(date?.toISOString());
                onChange?.(date);
              }}
              popperPlacement="right"
              className="w-100 w-full"
              disabled={disabled}
              {...(min ? {minDate: new Date(min)} : {})}
              {...(max ? {maxDate: new Date(max)} : {})}
            />

            <div className="date-picker-icon">
              <svg
                stroke="currentColor"
                fill="currentColor"
                strokeWidth="0"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
              >
                <path fill="none" d="M0 0h24v24H0z"></path>
                <path d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zm0-12H5V6h14v2zM9 14H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2zm-8 4H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2z"></path>
              </svg>
            </div>
          </div>
        )}
      />

      <div className="app-datepicker-error">
        <ErrorMessage errors={errors} name={registerName} as={"span"} />
      </div>
    </div>
  );
};

export default DatePicker;
